class tools {
    constructor() {
        
    }

    set_title(text){
        document.title = text;
    }

    set_theme(theme){
        switch(theme){
            case "blue":
                document.documentElement.style.setProperty("--C1", "#034B7B");
                document.documentElement.style.setProperty("--C2", "#005DA5");
                document.documentElement.style.setProperty("--C3", "#D7E9F7");
                break;
            case "darkblue":
                document.documentElement.style.setProperty("--C1","#293955");
                document.documentElement.style.setProperty("--C2","#293955");
                document.documentElement.style.setProperty("--C3","#DFE9FB");
                break;
            case "lightblue":
                document.documentElement.style.setProperty("--C1", "#293955");
                document.documentElement.style.setProperty("--C2", "#7EAAFB");
                document.documentElement.style.setProperty("--C3", "#DFE9FB");
                break;
            case "turquoise":
                document.documentElement.style.setProperty("--C1", "#107594");
                document.documentElement.style.setProperty("--C2", "#0e87ad");
                document.documentElement.style.setProperty("--C3", "#D7F2FA");
                break;
            case "darkgreen":
                document.documentElement.style.setProperty("--C1", "#274602");
                document.documentElement.style.setProperty("--C2", "#386600");
                document.documentElement.style.setProperty("--C3", "#D7F3B5");
                break;
            case "green":
                document.documentElement.style.setProperty("--C1", "#006400");
                document.documentElement.style.setProperty("--C2", "#008B00");
                document.documentElement.style.setProperty("--C3", "#CCFFCC");
                break;
            case "red":
                document.documentElement.style.setProperty("--C1", "#510513");
                document.documentElement.style.setProperty("--C2", "#6d071a");
                document.documentElement.style.setProperty("--C3", "#FCCFD7");
                break;
            case "darkred":
                document.documentElement.style.setProperty("--C1", "#6A0404");
                document.documentElement.style.setProperty("--C2", "#9E0707");
                document.documentElement.style.setProperty("--C3", "#FDCECE");
                break;
            case "darkorange":
                document.documentElement.style.setProperty("--C1", "#9C1E02");
                document.documentElement.style.setProperty("--C2", "#BF2407");
                document.documentElement.style.setProperty("--C3", "#FDD5CE");
                break;
            case "orange":
                document.documentElement.style.setProperty("--C1", "#CD3700");
                document.documentElement.style.setProperty("--C2", "#E04006");
                document.documentElement.style.setProperty("--C3", "#FEDACD");
                break;
            case "purple":
                document.documentElement.style.setProperty("--C1", "#4B0082");
                document.documentElement.style.setProperty("--C2", "#68228B");
                document.documentElement.style.setProperty("--C3", "#EBD6F5");
                break;
            case "brown":
                document.documentElement.style.setProperty("--C1", "#663300");
                document.documentElement.style.setProperty("--C2", "#AB5500");
                document.documentElement.style.setProperty("--C3", "#FFE6CC");
                break;
            case "darkgray":
                document.documentElement.style.setProperty("--C1", "#333333");
                document.documentElement.style.setProperty("--C2", "#666666");
                document.documentElement.style.setProperty("--C3", "#fafafa");
                break;
        }
    }

    set_background(color){
        if (color=="light"){
            document.documentElement.style.setProperty("--T1", "#fff");
            document.documentElement.style.setProperty("--T2", "#f0f0f0");
            document.documentElement.style.setProperty("--T3", "#ddd");
            document.documentElement.style.setProperty("--TEXT", "#424242");
            document.documentElement.style.setProperty("--BORDER", "#666");
            document.documentElement.style.setProperty("--TITLE", "#034B7B");
        }
        if (color=="dark"){
            document.documentElement.style.setProperty("--T1", "#333");
            document.documentElement.style.setProperty("--T2", "#111");
            document.documentElement.style.setProperty("--T3", "#444");
            document.documentElement.style.setProperty("--TEXT", "#fff");
            document.documentElement.style.setProperty("--BORDER", "#222");
            document.documentElement.style.setProperty("--TITLE", "#fff");
        }
    }

    export_file(caption, extension, vdata) {

        var BOM = "\uFEFF";
        var data = BOM + vdata;
        var blob = new Blob([data], {encoding: "utf8",type: "text/csv;charset=utf-8"});
        var url = window.URL.createObjectURL(blob);

        var download_link = document.createElement('a');
        download_link.href = url;
        var ts = new Date().getTime();
        if (caption == "") {
            download_link.download = ts + extension;
        } else {
            download_link.download = caption + "-" + ts + extension;
        }
        document.body.appendChild(download_link);
        download_link.click();
        document.body.removeChild(download_link);
    }

    is_mobile() {
        return ( ( window.innerWidth <= 600 ) && ( window.innerHeight <= 800 ) );
    }
}

export default new tools()